import { Component } from '@angular/core';
import { GenericLovComponent } from 'src/app/tools/abstract-classes/generic-lov.component';
import { MatDialogRef } from '@angular/material/dialog';
import { SalesAdminService } from 'src/app/assabil-sales/services/sales-admin-service';
import { TargetProductFamily } from 'src/app/assabil-sales/models/entities/target-product-family';


@Component({
  selector: 'target-product-family-lov',
  templateUrl: './target-product-family-lov.component.html',
  styleUrls: ['./target-product-family-lov.component.scss']
})

export class TargetProductFamilyLovComponent extends GenericLovComponent   {

   code         : string; 
   name         : string; 

   targetProductFamilys: TargetProductFamily[] = [];

    columns = [
        {  prop: 'targetProductFamilyCode',  name: 'Code'},
        {  prop: 'name',                     name: 'Nom'}
    ]


//----------------------------------------------------------------------
constructor( 
    public dialogRef: MatDialogRef<TargetProductFamilyLovComponent>,
    protected salesAdminService  : SalesAdminService) {
    super();
    this.entityName = "targetProductFamily";
}
//----------------------------------------------------------------------
    


//----------------------------------------------------------------------
loadData() {
    this.salesAdminService.targetProductFamilysGet(this.code, this.name).then(result => {
        this.targetProductFamilys = result;
    })
}
//----------------------------------------------------------------------


//----------------------------------------------------------------------
closeModal(row : TargetProductFamily){
    this.dialogRef.close(row);
}
//----------------------------------------------------------------------

}
